<div class="container" *transloco="let t">
    <div class="title">
        {{t('onboarding-welcome-1')}}
    </div>
    <div class="body">
        {{t('onboarding-welcome-2')}}
        <br>
        {{t('onboarding-welcome-3')}}
    </div>
    <mat-spinner [diameter]="30" class="spinner">
    </mat-spinner>
</div>
